import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useStudentTeachersQuery } from '../../slices/students/studentsApiSlice'
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import NoSubject from '../../components/NoSubject';
import TeacherCard from '../../components/TeacherCard';
import PaginateNewAnswers from '../../components/PaginateNewAnswers';


const StudentTeachers = () => {

    const { pageNumber } = useParams();

    const navigate = useNavigate();

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
      if(!studentInfo) {
          navigate('/studentlogin')
      }   
  }, [navigate, studentInfo])

  const { data, isLoading, error } = useStudentTeachersQuery({pageNumber});

  return (
    <div>
      <StudentNavbar />
        <div className="main-content" id="panel">
          <StudentHeader /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
              {isLoading ? ( 
                <Loader />
              ) : error ? (
                <Message variant='danger'>
                  {error?.data?.message || error.error}
                </Message>
              ) : (
                <div className="row">
                  <h3 className="centerTitle tittleColor4 ">
                    <span className='tittleColor4'>
                      My Teachers
                    </span>
                  </h3><br /><br />
                  {data?.teachers.map((teacher) => (
                    <div key={teacher._id} className="col-md-6 col-xl-4 ">
                      <TeacherCard teacher={teacher} />                     
                    </div>
                  ))}  
                  {data?.teachers.length == 0 && 
                    <div className="col-md-6 col-xl-4  ">
                      <NoSubject  />
                    </div>
                  }
                  <PaginateNewAnswers
                            pages={data?.pages}
                            page={data?.page}
                            link='studentteachers'
                            className='pagCenterStudent'                                                
                        />
                </div>
              )} 
            </div>      
        </div>
    </div>
  )
}

export default StudentTeachers
